import React from 'react';
import { TableRow, TableCell } from '../../../components/ui/table';
import { SeriesTable } from './seriesTable';
import { SeriesData } from '@/types/types';

interface TableExpandedRowProps {
  colSpan: number;
  isLoading: boolean;
  error?: string;
  series?: SeriesData[];
  className?: string;
}

export const TableExpandedRow: React.FC<TableExpandedRowProps> = ({
  colSpan,
  isLoading,
  error,
  series,
  className = 'bg-gray-50 border-2 border-t-0 border-blue-400 rounded-b-[10px] overflow-hidden',
}) => {
  return (
    <TableRow className={className}>
      <TableCell colSpan={colSpan}>
        {isLoading ? (
          <div className="p-4 text-sm text-gray-700">
            Loading series data...
          </div>
        ) : error ? (
          <div className="p-4 text-sm text-red-600">{error}</div>
        ) : series && series.length > 0 ? (
          <SeriesTable series={series} />
        ) : (
          <div className="p-4 text-sm text-gray-700">No series data found.</div>
        )}
      </TableCell>
    </TableRow>
  );
};
